<template>
  <div
    :class="{
      'd-flex': true,
      'flex-row': $vuetify.breakpoint.lgAndDown,
      'flex-column': $vuetify.breakpoint.xs,
      'gap-h-20': reprocessButtonRules.show && exportButtonRules.show && $vuetify.breakpoint.smAndUp,
      'gap-v-20': reprocessButtonRules.show && exportButtonRules.show && $vuetify.breakpoint.xs,
    }">
    <v-tooltip
      bottom
      :disabled="!reprocessButtonRules.disabled">
      <template v-slot:activator="{ on, attrs }">
        <div
          v-on="on"
          v-bind="attrs">
          <v-btn
            v-if="reprocessButtonRules.show"
            :disabled="reprocessButtonRules.disabled"
            outlined
            color="primary"
            :style="btnAction.style"
            @click="reprocessMajorities">
            <v-icon left>
              mdi-reload
            </v-icon>

            Reprocessar
          </v-btn>
        </div>
      </template>

      <span v-html="sanitize(invalidReprocessMessage)"/>
    </v-tooltip>

    <v-tooltip
      bottom
      :disabled="!exportButtonRules.disabled">
      <template v-slot:activator="{ on, attrs }">
        <div
          v-on="on"
          v-bind="attrs">

          <v-btn
            v-if="exportButtonRules.show"
            :disabled="exportButtonRules.disabled"
            color="primary"
            :style="btnAction.style"
            @click="showExportModal">
            <v-icon left color="foreground-accent">
              mdi-export-variant
            </v-icon>

            Exportar
          </v-btn>
        </div>
      </template>

      <span>
        Selecione ao menos o filtro Grupo Financeiro para poder exportar.
      </span>
    </v-tooltip>
  </div>
</template>

<script>
import GenericFunctionsMixin from '@/shared/mixins/genericFunctions/genericFunctionsMixin';
import MajorityMixin from '@/shared/mixins/majority/majorityMixin';
import MajorityRules from '../../rules/majorityRules';
import { mapActions, mapMutations } from 'vuex';

export default {
  name: "MajorityActions",

  mixins: [
    GenericFunctionsMixin,
    MajorityMixin,
    MajorityRules,
  ],

  methods: {
    ...mapActions({
      exportReport: 'majority/exportReport',
      requestReprocess: 'majority/requestReprocess',
    }),

    ...mapMutations({
      showExportRequestModal: 'majority/showExportRequestModal',
    }),

    async reprocessMajorities() {
      await this.requestReprocess()
        .then((result) => this.showMessage('success', 'Reprocessamento realizado!'))
        .catch((error) => {
          this.showMessage('error', 'Ocorreu um erro durante solicitação de reprocessamento!');
        });
    },

    showExportModal() {
      this.showExportRequestModal(true);
    },

    showMessage(statusMessage, message) {
      const majoritySnackbar = this.majorityViewReference()?.$refs.MajoritySnackbar || false;

      majoritySnackbar.open(
        statusMessage,
        message
      );
    }
  }
}
</script>